/**
 * 🌍 环境常量配置
 *
 * 定义项目中使用的环境类型和对应的 API 目标地址
 */

/**
 * 环境枚举
 */
export enum Env {
  /** 开发环境 */
  DEV = 'dev',
  /** 测试环境 */
  TEST = 'test',
  /** 生产环境 */
  PROD = 'prod',
}

// /**
//  * 获取当前环境
//  */
// export const getCurrentEnv = (): Env => {
//   const env = process.env.UMI_ENV || process.env.NODE_ENV;

//   switch (env) {
//     case 'test':
//       return Env.TEST;
//     case 'production':
//     case 'prod':
//       return Env.PROD;
//     case 'development':
//     case 'dev':
//     default:
//       return Env.DEV;
//   }
// };

// /**
//  * 判断是否为生产环境
//  */
// export const isProduction = (): boolean => {
//   return getCurrentEnv() === Env.PROD;
// };

// /**
//  * 判断是否为开发环境
//  */
// export const isDevelopment = (): boolean => {
//   return getCurrentEnv() === Env.DEV;
// };

// /**
//  * 判断是否为测试环境
//  */
// export const isTest = (): boolean => {
//   return getCurrentEnv() === Env.TEST;
// };
